import { Link } from 'react-router-dom';
import type { Recommendation } from '@/mocks/siteData';

interface RecommendCardProps {
  item: Recommendation;
  index: number;
}

export default function RecommendCard({ item, index }: RecommendCardProps) {
  return (
    <article className="group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-accent-400 transition-colors h-full">
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-100">
        <img
          src={item.poster}
          alt={`${item.title} 剧集海报`}
          title={`${item.title} - 相关推荐影视资源`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-primary-950 text-[11px] font-medium">
          推荐 {index + 1}
        </span>
      </div>
      <div className="p-4 flex flex-col flex-1">
        <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
          <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-900">
            {item.genre}
          </span>
          <span>{item.year}</span>
        </div>
        <h3 className="font-heading font-semibold text-foreground-950 text-base mb-2">
          {item.title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
          {item.summary}
        </p>
        <div className="mt-auto pt-3 border-t border-background-200">
          <p className="text-xs text-foreground-500 leading-relaxed">
            <span className="text-accent-700 font-medium">推荐理由：</span>
            {item.reason}
          </p>
          <Link
            to="/special/recommend"
            className="mt-3 inline-flex items-center gap-1 text-sm text-primary-700 font-medium hover:text-accent-600 transition-colors"
          >
            查看专题
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}